import DevisesController from './devises.controller';

export default {
    template: require('./devises.tpl.html'),
    controller: DevisesController
};
